import { createFileRoute, Outlet } from '@tanstack/react-router';
import Header from '@my-pages/layout/Header.tsx';
import Footer from '@my-pages/layout/Footer.tsx';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import { Menu } from '@my-pages/features/auth/components/menu';

export const Route = createFileRoute('/_cms')({
    component: RouteComponent,
});

function RouteComponent() {
    const isAuthenticated = useApplicationStore((state) => state.isAuthenticated);

    return (
        <>
            <Header />
            <div className='main-wrapper notranslate'>
                {isAuthenticated ? <Menu /> : null}
                <main
                    className='main-content d-flex flex-wrap'
                    role='main'
                >
                    <div className='container-lg'>
                        <Outlet />
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
}
